import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {OfferStatusEnum} from "@app/enums/offer-status.enum";
import {ModalContainerComponent} from "@app/modal/modal-container/modal-container.component";
import {PersonalOfferInterface, RedistributionRequestInterface} from "@app/redistribution/redistribution.interface";
import {NgIf} from "@angular/common";
import {
  RedistributionStatusComponent
} from "@app/redistribution/shared/redistribution-status/redistribution-status.component";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {RedistributionApiService} from "@app/redistribution/services/redistribution-api.service";
import {LoadingAnimationComponent} from "@app/loading-animation/loading-animation.component";
import {catchError, throwError} from "rxjs";
import {ToastService} from "@app/toast/toast.service";
import {DropdownComponent} from "@app/dropdown/dropdown.component";

@Component({
  selector: 'app-cancel-redistribution-request',
  templateUrl: './modal-cancel-redistribution-request.component.html',
  styleUrls: ['./modal-cancel-redistribution-request.component.scss'],
  standalone: true,
  imports: [
    ModalContainerComponent,
    NgIf,
    RedistributionStatusComponent,
    ReactiveFormsModule,
    LoadingAnimationComponent,
    DropdownComponent
  ]
})
export class ModalCancelRedistributionRequestComponent implements OnInit {
  isLoading = false;
  
  @Input() redistributionRequest!: RedistributionRequestInterface;
  @Input() personalOffer!: PersonalOfferInterface;
  @Output() updateData = new EventEmitter<void>();
  
  @ViewChild('modalContainer') modalContainer!: ModalContainerComponent;
  @ViewChild('textEl', { static: true }) textEl!: ElementRef<HTMLTextAreaElement>;
  
  constructor(
      private redistributionApiService: RedistributionApiService,
      private toastService: ToastService,
  ) { }
  
  ngOnInit(): void {
  
  }
  
  open() {
    this.modalContainer.openModal()
    this.isLoading = false;
    this.textEl.nativeElement.value = '';
  }
  
  close() {}
  
  save() {
    if (!this.textEl.nativeElement.value.length) {
      return
    }
    
    this.isLoading = true;
    this.redistributionApiService.cancelRedistributionRequest(this.redistributionRequest.id, this.textEl.nativeElement.value)
        .pipe(
            catchError((error) => {
              this.toastService.showError(error.error.messages[1]);
              this.isLoading = false;
              return throwError(() => error);
            })
        )
        .subscribe(() => {
          this.isLoading = false;
          this.updateData.emit();
          this.toastService.showSuccess('Запис успішно оновлено.');
          this.modalContainer.close();
        })
  }
  
  cancel() {
    this.modalContainer.close();
  }

}
